import React, { SVGProps } from 'react';

export const Profile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.9 22.5h-1.8c0-4.096 0-6.569-8.1-6.569S3.9 18.405 3.9 22.5H2.1c0-4.9.71-8.368 9.9-8.368 9.188 0 9.9 3.467 9.9 8.368ZM6.6 6.75c0-3.55 2.716-5.406 5.4-5.406S17.4 3.2 17.4 6.75c0 3.182-2.22 5.406-5.4 5.406S6.6 9.932 6.6 6.75Zm1.8 0c0 2.224 1.38 3.607 3.6 3.607s3.6-1.382 3.6-3.607c0-2.49-1.807-3.606-3.6-3.606-1.792 0-3.6 1.116-3.6 3.606Z"
    />
  </svg>
);
